import axios from "axios";
const apiBase = process.env.REACT_APP_BASE_API_URL

/**
 * interceptor for axios calls
 */
axios.interceptors.request.use(
  (config: any) => {
    const user: any = JSON.parse(localStorage.getItem("userInfo") as string);
   
    if (config.url.includes("s3.amazonaws.com")) {
      return config;
    }
    config.header = { ...config.headers, "Content-Type": "application/json" };
    if (
      !config.url.endsWith("/user") &&
      user &&
      !config.headers.Authorization
    ) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: any) => {
    if (response.data.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    const { data } = response;
    return data;
  },
  (error) => {
    // A real HTTP 401 means the API could not authenticate the caller at all:
    // no token, or one that is malformed, expired or wrongly signed. Only the
    // in-body `status: 401` convention was handled above, so an expired admin
    // session used to surface as an unhandled rejection instead of a clean
    // return to the login screen.
    //
    // Two deliberate limits. We never redirect on 403, because the API uses it
    // for "signed in, but not allowed to do this" (wrong store, not an admin)
    // and logging those users out would be wrong. And we only redirect when a
    // session actually exists, so public token-holders — survey respondents and
    // onboarding employees, who have no account — are left to their screen's
    // own error handling rather than being sent to an admin login page.
    if (error?.response?.status === 401 && localStorage.getItem("userInfo")) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

/**
 * post api wrapper for axios
 * @param path string
 * @param data object / array
 * @returns response object
 */
export const post = async (path: string, data: any, publicToken?: string) => {
  // console.log("+api.ts: post: path, data, publicToken = ", path, data, publicToken);
  if (publicToken) {
    return await axios.post(apiBase + path, data, {
      headers: { Authorization: `Bearer ${publicToken}` },
    });
  }
  return await axios.post(apiBase + path, data);
};

/**
 * Get api wrapper for axios
 * @param path string
 * @returns response object
 */
export const get = async (path: string, publicToken?: string) => {
  if (publicToken) {
    return await axios.get(apiBase + path, {
      headers: { Authorization: `Bearer ${publicToken}` },
    });
  }
  return await axios.get(apiBase + path);
};

/**
 * put api wrapper for axios
 * @param path string
 * @param data object / array
 * @returns response object
 */
export const put = async (path: string, data: any) => {
  return await axios.put(apiBase + path, data);
};

export const deleteReq = async (path: string, data?: any) => {
  return await axios.delete(apiBase + path, data);
};

/* export const postForm = async (path: any, data: any) => {
  const response = await axios.post(apiBase + path, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};
 */
